import { useRef } from "react";
import { Box, Typography, Link, Stack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AppLogoLightMode from "src/assets/images/drugvlab_logo_light_mode.svg";
import { useAppSelector } from "src/store/app/hooks";
import { RootState } from "src/store/app/store";

const BRAND = "#2f5596";

// 푸터 안내 페이지 정의
const FooterPage = () => {
  const { t } = useTranslation();
  const footerRef = useRef<HTMLDivElement>(null);
  const year = new Date().getFullYear();
  const isCollapsed = useAppSelector((state: RootState) => state.drawer.isCollapsed);
  const drawerWidth = useAppSelector((state: RootState) => state.drawer.drawerWidth);
  const currentWidth = isCollapsed ? 80 : drawerWidth;


//////////////////////////////////////////////////////////////////////////////////////////////////////////////// 페이지 렌더링 ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <Box
      ref={footerRef}
      component="footer"
      sx={{
        bottom: 0,
        width: `calc(100% - ${currentWidth}px)`,
        ml: `${currentWidth}px`,
        transition: "left 0.3s ease, width 0.3s ease",
        borderTop: "1px solid #edf2f7",
        backgroundColor: "white",
        py: 2.5,
        px: { xs: 3, md: 5 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginLeft: 5,
          marginTop: 5,
          cursor: "pointer",
        }}
      >
        <img
          src={AppLogoLightMode}
          alt="logo"
          height={55}
          style={{ verticalAlign: "middle" }}
        />
      </Box>
      <Stack alignItems="center" spacing={1.2}>
        {/* 링크 */}
        <Stack direction="row" alignItems="center">
          {[
            { label: t("footer.terms"), href: "/terms-of-service" },
            { label: t("footer.privacy"), href: "/privacy-policy" },
            { label: t("footer.faq"), href: "/faq" },
            {
              label: t("footer.contact"),
              href: "/contact-us",
            },
          ]?.map((item, i, arr) => (
            <Stack key={item.href} direction="row" alignItems="center">
              {item.href.startsWith("/") ? (
                <Link
                  component={RouterLink}
                  to={item.href}
                  underline="none"
                  sx={{
                    fontSize: "0.72rem",
                    color: "#718096",
                    px: 1.5,
                    py: 0.4,
                    borderRadius: "6px",
                    transition: "all 0.15s ease",
                    "&:hover": {
                      color: BRAND,
                      backgroundColor: "rgba(47,85,150,0.06)",
                    },
                  }}
                >
                  {item.label}
                </Link>
              ) : (
                <Link
                  href={item.href}
                  underline="none"
                  sx={{
                    fontSize: "0.72rem",
                    color: "#718096",
                    px: 1.5,
                    py: 0.4,
                    borderRadius: "6px",
                    transition: "all 0.15s ease",
                    "&:hover": {
                      color: BRAND,
                      backgroundColor: "rgba(47,85,150,0.06)",
                    },
                  }}
                >
                  {item.label}
                </Link>
              )}
              {i < arr.length - 1 && (
                <Box
                  sx={{ width: "1px", height: 10, backgroundColor: "#e2e8f0" }}
                />
              )}
            </Stack>
          ))}
        </Stack>

        <Stack
          spacing={0.45}
          alignItems="center"
          sx={{ textAlign: "center", mt: 0.5 }}
        >
          <Typography
            sx={{
              fontSize: "0.72rem",
              color: "#718096",
              letterSpacing: "0.01em",
            }}
          >
            Contact:{" "}
            <Link
              href="mailto:tester@aigendrug.com"
              underline="hover"
              sx={{ color: BRAND, fontWeight: 600 }}
            >
              tester@aigendrug.com
            </Link>
          </Typography>
          <Typography
            sx={{
              fontSize: "0.7rem",
              color: "#a0aec0",
              letterSpacing: "0.01em",
            }}
          >
            Headquarter 638, 220, 1, Gwanak-ro, Gwanak-gu, Seoul, Republic of
            Korea
          </Typography>
          <Typography
            sx={{
              fontSize: "0.7rem",
              color: "#a0aec0",
              letterSpacing: "0.01em",
            }}
          >
            Research Center 901, 1793, Nambusunhwan-ro, Gwanak-gu, Seoul,
            Republic of Korea
          </Typography>
          <Typography
            sx={{
              fontSize: "0.7rem",
              color: "#a0aec0",
              letterSpacing: "0.01em",
            }}
          >
            Tel +82 70 4902 0716
          </Typography>
        </Stack>

        {/* 저작권 + 버전 */}
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Typography
            sx={{
              fontSize: "0.7rem",
              color: "#a0aec0",
              letterSpacing: "0.02em",
            }}
          >
            © {year}{" "}
            <Box component="span" sx={{ color: BRAND, fontWeight: 600 }}>
              AIGENDRUG
            </Box>{" "}
            Co., Ltd. All rights reserved.
          </Typography>
          <Box sx={{ width: "1px", height: 10, backgroundColor: "#e2e8f0" }} />
          <Typography
            sx={{
              fontSize: "0.7rem",
              color: "#a0aec0",
              letterSpacing: "0.02em",
            }}
          >
            DrugVLAB™
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default FooterPage;
